import * as types from '../actions/types';

const INITIAL_STATE = {
  stages: [],
  subjects: [],
  subSubjects: [],
  subjectKey: '',
  subjectId: '',
  categoryId: '',
  stage: '',
  subjectsCategories: [],
  onProgress: '',
  completed: '',
  nbHits: '',
  error: {
    type: '',
    message: '',
  },
};

const stagesReducer = (state = INITIAL_STATE, { payload, type, error }) => {
  // store cities used in signup
  switch (type) {
    case types.GET_STAGES_REQUEST:
      return {
        ...state,
        stages: [],
        subjects: [],
        subSubjects: [],
        onProgress: 'GET_STAGES_REQUEST',
      };
    case types.GET_STAGES_SUCCESS:
      return {
        ...state,
        stages: payload,
        onProgress: '',
      };
    case types.GET_SUBJECTS_REQUEST:
      return {
        ...state,
        subjects: [],
        subSubjects: [],
        onProgress: 'GET_SUBJECTS_REQUEST',
      };
    case types.GET_SUBJECTS_SUCCESS:
      return {
        ...state,
        subjects: payload,
        onProgress: '',
      };
    case types.REQUEST_SUBJECT_REQUEST:
      return {
        ...state,
        onProgress: 'REQUEST_SUBJECT',
        completed: '',
        error: {},
        subSubjects: [],
      };
    case types.REQUEST_SUBJECT_SUCCESS:
      return {
        ...state,
        onProgress: '',
        completed: 'REQUEST_SUBJECT',
      };
    case types.GET_SUB_SUBJECTS_REQUEST:
      return {
        ...state,
        onProgress: 'GET_SUB_SUBJECTS_REQUEST',
      };
    case types.GET_SUB_SUBJECTS_SUCCESS:
      return {
        ...state,
        subSubjects: payload,
        onProgress: '',
      };
    case types.REQUEST_SUBJECT_FAIL:
      return {
        ...state,
        error: {
          type: 'REQUEST_SUBJECT',
          message: error,
        },
      };
    case types.SET_SEARCH_WORD:
      return {
        ...state,
        subjectKey: payload.subjectKey,
        subjectId: payload.subjectId,
        categoryId: payload.categoryId,
        stage: payload.stage || state.stage,
      };
    case types.RESET_SEARCH_WORD:
      return {
        ...state,
        subjectKey: '',
      };
    case types.SET_STAGE:
      return {
        ...state,
        stage: payload.stage,
      };
    case types.SET_SUBJECTS:
      return {
        ...state,
        subjectsCategories: payload,
      };
    case types.RESET_CURRENT_REFINMENTS:
      return {
        ...state,
        subjectsCategories: '',
        stages: '',
      };
    case types.SET_NUMBER_OF_HITS:
      return {
        ...state,
        nbHits: payload,
      };
    case types.RESET_INDICATORS:
      return {
        ...state,
        onProgress: '',
        completed: '',
        error: {},
      };

    default:
      return { ...state };
  }
};

export default stagesReducer;
